import { ModuleSettingsStore } from "../contentstack/moduleSettingsStore.js";
import { FILTER_OPTION_IDS, FILTER_PARAM_TYPES, BUSINESS_CENTER_REGION_CA, BUSINESS_CENTER_REGION } from "./constants.js";
import { ZodError, z } from "zod";
const getWarehouseOptionsDetails = (moduleSettings, hasExtendedOptions = false) => {
  const msStore = new ModuleSettingsStore({
    composable_window: moduleSettings.composable_window,
    key_value: moduleSettings.key_value
  });
  const properties = moduleSettings.properties[0];
  const mapOptions = (options) => options.map((option) => ({
    iconName: properties.optionDetails[option].icon,
    id: option,
    label: msStore.getKeyValueItem(option),
    selectedByDefault: properties.optionDetails[option].selectByDefault,
    warehouseLocationsPage: properties.optionDetails[option].filterParams.warehouseLocationsPage || "",
    warehouseLocatorMobileApi: properties.optionDetails[option].filterParams.warehouseLocatorMobileApi || ""
  }));
  const baseOptions = mapOptions(properties.baseOptions);
  const extendedOptions = hasExtendedOptions ? mapOptions(properties.extendedOptions) : [];
  return [...baseOptions, ...extendedOptions];
};
const getFiltersInitial = (moduleSettings) => {
  const drawerOptionsDetails = getWarehouseOptionsDetails(moduleSettings);
  return drawerOptionsDetails.reduce((obj, filter) => {
    return {
      ...obj,
      [filter.id]: filter.selectedByDefault
    };
  }, {});
};
const getFiltersFromUrlParams = (queryParams, moduleSettings) => {
  const drawerOptionsDetails = getWarehouseOptionsDetails(moduleSettings);
  const urlFilters = {};
  const urlToInternalMap = {
    hasTires: "tirecenteroption",
    hasBusiness: "businesscenteroption",
    hasGas: "gasstationoption",
    hasFood: "foodcourtoption",
    hasHearing: "hearingaidoption",
    hasPharmacy: "pharmacyoption",
    hasOptical: "opticaloption",
    hasCarWash: "carwashoption"
  };
  Object.entries(urlToInternalMap).forEach(([urlParam, internalKey]) => {
    const urlValue = queryParams.get(urlParam);
    if (urlValue === "true") {
      const filterExists = drawerOptionsDetails.some(
        (option) => option.id === internalKey
      );
      if (filterExists) {
        urlFilters[internalKey] = true;
      }
    }
  });
  return urlFilters;
};
const getFiltersInitialWithUrlParams = (moduleSettings, queryParams) => {
  const defaultFilters = getFiltersInitial(moduleSettings);
  if (!queryParams) {
    return defaultFilters;
  }
  const urlFilters = getFiltersFromUrlParams(queryParams, moduleSettings);
  return {
    ...defaultFilters,
    ...urlFilters
  };
};
const getCheckboxesValidationSchema = (moduleSettings) => {
  const drawerOptionsDetails = getWarehouseOptionsDetails(moduleSettings);
  return z.object(
    drawerOptionsDetails.reduce(
      (acc, { id }) => {
        acc[id] = z.boolean();
        return acc;
      },
      {}
    )
  );
};
const getValidationSchema = (moduleSettings) => {
  return z.object({
    filters: getCheckboxesValidationSchema(moduleSettings),
    searchText: z.string()
  });
};
const validateForm = (moduleSettings, values) => {
  try {
    getValidationSchema(moduleSettings).parse(values);
  } catch (error) {
    if (error instanceof ZodError) {
      return error.formErrors.fieldErrors;
    }
  }
};
const getWarehouseFilterParams = (drawerOptionsDetails, filters, filterParamType) => {
  return Object.entries(filters).reduce(
    (acc, [key, value]) => {
      const option = drawerOptionsDetails.find(
        (option2) => option2.id === key
      );
      if (key === FILTER_OPTION_IDS.BUSINESS_CENTER && filterParamType === FILTER_PARAM_TYPES.WAREHOUSE_LOCATOR_MOBILE_API) {
        if (value) {
          const site = (process.env.SITE || process.env.NEXT_PUBLIC_SITE || "usbc").toLowerCase();
          const businessCenterRegion = site.startsWith("ca") ? BUSINESS_CENTER_REGION_CA : BUSINESS_CENTER_REGION;
          acc["region"] = businessCenterRegion;
        }
      } else if (option == null ? void 0 : option[filterParamType]) {
        const paramName = option[filterParamType];
        acc[paramName] = value;
      }
      return acc;
    },
    {}
  );
};
export {
  getFiltersFromUrlParams,
  getFiltersInitial,
  getFiltersInitialWithUrlParams,
  getWarehouseFilterParams,
  getWarehouseOptionsDetails,
  validateForm
};
